// extracted by mini-css-extract-plugin
export default {"danger":"ConfirmDeleteGroupModal_danger__E60rd","usageList":"ConfirmDeleteGroupModal_usageList__Ob+NK"};